import { render, staticRenderFns } from "./VaccineInfoDialog.vue?vue&type=template&id=0f9682e4&scoped=true&"
import script from "./VaccineInfoDialog.vue?vue&type=script&lang=js&"
export * from "./VaccineInfoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9682e4",
  null
  
)

export default component.exports